import type { Activation } from '../../types/domain';
import { ApiClient } from '../config';

export interface ActivationsService {
  getActivationsByLicenseKey(licenseKey: string): Promise<Activation[]>;
  deactivateActivation(activationId: string, machineId: string): Promise<void>;
  reactivateActivation(activationId: string, machineId: string, licenseKey: string): Promise<void>;
}

export class ActivationsServiceImpl implements ActivationsService {
  private apiClient: ApiClient;

  constructor(apiClient: ApiClient) {
    this.apiClient = apiClient;
  }

  async getActivationsByLicenseKey(licenseKey: string): Promise<Activation[]> {
    console.log('[ActivationsService] Fetching activations for license:', licenseKey);
    try {
      const activations = await this.apiClient.get<Activation[]>(`/api/v1/licenses/${licenseKey}/activations`);
      console.log('[ActivationsService] Fetched activations:', activations);
      return activations;
    } catch (error) {
      console.error('[ActivationsService] Error fetching activations:', error);
      throw error;
    }
  }

  async deactivateActivation(activationId: string, machineId: string): Promise<void> {
    console.log('[ActivationsService] Deactivating activation:', activationId);
    try {
      // Updated to use the fixed delete method with a proper body parameter
      await this.apiClient.delete(`/api/v1/licenses/activations/${activationId}`, { machineId });
      console.log('[ActivationsService] Successfully deactivated activation');
    } catch (error) {
      console.error('[ActivationsService] Error deactivating activation:', error);
      throw error;
    }
  }
  
  async reactivateActivation(activationId: string, machineId: string, licenseKey: string): Promise<void> {
    console.log('[ActivationsService] Reactivating activation:', activationId);
    try {
      // Our license validation endpoint will reuse inactive activations automatically
      await this.apiClient.post(`/api/v1/licenses/validate`, {
        licenseKey,
        machineId 
      });
      console.log('[ActivationsService] Successfully reactivated activation');
    } catch (error) {
      console.error('[ActivationsService] Error reactivating activation:', error);
      throw error;
    }
  }
}

export const activationsService = new ActivationsServiceImpl(new ApiClient());